module.exports = __webpack_public_path__ + "img/ss.17098444.svg";